import Parse from "parse";

export interface ListAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  list: string;
}

export class List extends Parse.Object<ListAttributes> {
  static className: string = "OD3_BDE_List";

  constructor(data?: Partial<ListAttributes>) {
    super("OD3_BDE_List", data as ListAttributes);
  }

  get list(): string {
    return super.get("list");
  }
  set list(value: string) {
    super.set("list", value);
  }
}

Parse.Object.registerSubclass("OD3_BDE_List", List);
